/* eslint-disable no-magic-numbers */
import { MEGA } from "utils/common";
import { imageMaxBytes } from "widgets/social2/utils";

export const MAX_IMAGE_BYTES = imageMaxBytes(30 * MEGA);
